import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/booking-notes")({
  validateSearch: devSearchSchemaFor("booking-notes"),
  component: lazyRouteComponent(
    () => import("@/modules/coaching/booking/dev/BookingNotesPreview"),
    "BookingNotesPreview",
  ),
});
